<pmv-fieldset [header]="header" *ngIf="header; else nofieldset">
  <ng-container *ngTemplateOutlet="picklist"></ng-container>
</pmv-fieldset>

<ng-template #nofieldset>
  <ng-container *ngTemplateOutlet="picklist"></ng-container>
</ng-template>

<ng-template #picklist>
  <p-pickList
    [source]="source" [target]="target"
    [sourceHeader]="sourceHeader" [targetHeader]="targetHeader"
    [showSourceControls]="showSourceControls" [showTargetControls]="showTargetControls"
    [disabled]="disabled"
    (onMoveToTarget)="onMoveToTarget.emit($event)" (onMoveToSource)="onMoveToSource.emit($event)"
    (onMoveAllToTarget)="onMoveAllToTarget.emit($event)" (onMoveAllToSource)="onMoveAllToSource.emit($event)"
    (onSourceReorder)="onSourceReorder.emit($event)" (onTargetReorder)="onTargetReorder.emit($event)"
    (onSourceSelect)="onSourceSelect.emit($event)" (onTargetSelect)="onTargetSelect.emit($event)">

    <ng-template let-object pTemplate="item">
      {{ field ? resolveFieldData(object, field) : object }}
    </ng-template>
  </p-pickList>
</ng-template>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵbd.html